<template>
    <v-dialog v-model="$store.state.modalSuccess" @click:outside="closeDialog" width="440">
      <v-card>
        <v-card-title class="d-flex justify-end">
          <v-avatar size="20px">
            <img
              alt="Avatar"
              :src="require('@/assets/icon/x.png')"
              @click="closeDialog"
            />
          </v-avatar>
        </v-card-title>

        <v-card-text class="d-flex flex-column justify-center align-center">
          <v-avatar size="146.25px">
            <img
              alt="Avatar"
              :src="require('@/assets/icon/Succes_G.png')"
            />
          </v-avatar>
          <p class="size-dialog py-5">{{name}}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: 'สร้างเอกสารสำเร็จ'
    }
  },
  methods: {
    closeDialog () {
      this.$store.state.modalSuccess = false
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
::v-deep .v-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.padding-verti-50 {
  padding-bottom: 50px;
  padding-top: 50px;
}
</style>
